import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import type { PolymorphicTypographyProps } from "../../types";

const DESKTOP_BREAKPOINT = 1024;

export const Root = styled(Box)(({ theme }) => ({
  maxWidth: 280,
  [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
    gridColumn: "1 / -1",
    maxWidth: "100%",
  },
}));

export const LogoWrapper = styled(Box)({
  display: "inline-flex",
  marginBottom: 24,
});

export const Heading = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.2px",
    lineHeight: 1.3,
    margin: "0 0 18px",
    color: theme.palette.text.primary,
  })
);

export const FormWrapper = styled(Box)({
  marginBottom: 14,
});

export const Description = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
    fontSize: 13,
    lineHeight: 1.55,
    margin: 0,
    color: theme.palette.text.secondary,
  })
);
